export default __webpack_public_path__ + "static/media/Cloud.aba8c70e.jpg";